/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
// chakra imports

export function SidebarLinks(props) {
  // Chakra color mode
  let location = useLocation();

  const { routes, onLinkClick } = props;

  // verifies active route by matching full path segments (avoid substring matches)
  const isRouteActive = (route) => {
    const routeFullPath =
      route.layout !== "/" ? `${route.layout}/${route.path}` : `/${route.path}`;
    const currentPath = location.pathname;
    return (
      currentPath === routeFullPath || currentPath.startsWith(`${routeFullPath}/`)
    );
  };

  const createLinks = (routes) => {
    return routes.map((route, index) => {
      if (
        (route.layout === "/" || route.layout === "/auth") &&
        route.name !== "Sign In"
      ) {
        return (
          <Link
            key={index}
            to={
              route.layout !== "/"
                ? route.layout + "/" + route.path
                : "/" + route.path
            }
            onClick={() => (typeof onLinkClick === "function" ? onLinkClick() : undefined)}
          >
            <div className="relative mb-3 flex hover:cursor-pointer">
              <li
                className="my-[3px] flex cursor-pointer items-center px-8"
                key={index}
              >
                <span
                  className={`${
                    isRouteActive(route) === true
                      ? "font-bold text-white"
                      : "font-medium text-[#8E8E8E]"
                  }`}
                >
                  {route.icon ? route.icon : <DashIcon />}{" "}
                </span>
                <p
                  className={`leading-1 ml-4 flex ${
                    isRouteActive(route) === true
                      ? "font-bold text-white"
                      : "font-medium text-[#8E8E8E]"
                  }`}
                >
                  {route.name}
                </p>
              </li>
              {isRouteActive(route) ? (
                <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-orangePrimary" />
              ) : null}
            </div>
          </Link>
        );
      }
    });
  };
  // BRAND
  return createLinks(routes);
}

export default SidebarLinks;
